import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import Shoppers from "../../../Assets/images/shoppers.svg";
import Dollar from "../../../Assets/images/doller.svg";

const parseNum = (v) => parseFloat(String(v || 0).replace(/,/g, "")) || 0;

const UserSaleSummary = ({ retailerfeed, summaryLoader, retailerarr }) => {
  return (
    summaryLoader ? (
      <div className="Clip_Loader" style={{ minHeight: "280px" }}>
        <ClipLoader color={"rgb(0, 143, 251)"} loading={true} size={50} />
      </div>
    ) :
      <div className="h-100">
        <div className="OverView_Outer_Block">
          <div className="Overview">
            <div className="Card_Body p-0">
              <div className="table-responsive Sales_Summery_Table">
                <table className="table">
                  <thead>
                    <tr>
                      <th width="40%"></th>
                      <th>
                        <div className="Sales_Summery_Table_Head_Ttl">
                          <div className="Icon">
                            <img src={Shoppers} className="img-fluid" alt="Retailer" />
                          </div>
                          <span>Users</span>
                        </div>
                      </th>
                      <th>
                        <div className="Sales_Summery_Table_Head_Ttl">
                          <div className="Icon">
                            <img src={Shoppers} className="img-fluid" alt="Retailer" />
                          </div>
                          <span>Shoppers</span>
                        </div>
                      </th>
                      <th>
                        <div className="Sales_Summery_Table_Head_Ttl">
                          <div className="Icon">
                            <img src={Dollar} className="img-fluid" alt="Retailer" />
                          </div>
                          <span>Units Sold</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {retailerarr.length > 0 ? (
                      <>
                        {Object.keys(retailerfeed).map((val, idx) =>
                          parseNum(retailerfeed[val].Users) > 0 ? (
                            <tr key={idx}>
                              <td>
                                <span>
                                  {retailerfeed[val].RetailerName
                                    ? retailerfeed[val].RetailerName
                                    : retailerfeed[val].WholeSalerName}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {Math.round(parseNum(retailerfeed[val].TotalUsers)).toLocaleString()}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {Math.round(parseNum(retailerfeed[val].Users)).toLocaleString()}
                                </span>
                              </td>
                              <td className="newOverview">
                                <span>{Math.round(parseNum(retailerfeed[val].UnitsSold)).toLocaleString()}</span>
                              </td>
                            </tr>
                          ) : ""
                        )}
                      </>
                    ) : (
                      <>
                        {Object.keys(retailerfeed).map((val, idx) =>
                          parseNum(retailerfeed[val].Users) > 0 ? (
                            <tr key={idx}>
                              <td>
                                <span>
                                  {retailerfeed[val].RetailerName
                                    ? retailerfeed[val].RetailerName
                                    : retailerfeed[val].WholeSalerName}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {Math.round(parseNum(retailerfeed[val].TotalUsers)).toLocaleString()}
                                </span>
                              </td>
                              <td>
                                <span>
                                  {Math.round(parseNum(retailerfeed[val].Users)).toLocaleString()}
                                </span>
                              </td>
                              <td>
                                <span>{Math.round(parseNum(retailerfeed[val].UnitsSold)).toLocaleString()}</span>
                              </td>
                            </tr>
                          ) : ""
                        )}
</>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default UserSaleSummary;
